export default {"src":"/_next/static/media/outdoor-lighting.4e47025a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};